<template>

  <v-dialog v-model="val" persistent width="400">
    <v-card color="primary" dark>
      <v-card-text>

         {{mesaj}} {{ $t('Your-process-progress') }}
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    props: ["value","mesaj"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    beforeMount: beforeMount,
    methods: {
    },
    data() {
      return {
      }
    },

    watch: {
    },
  }

  function beforeMount() {
  }

</script>